import { BufferTrackerReact as BufferTracker } from '@buffer-mono/tracking-plan'

import type { PlanSelectorPlanCycleClickedTrackingArguments } from './PlanSelectorTrackingTypes'

import { hasPaymentDetails, getOrganization } from '../../common/utils/user'

import { shouldPerformTrackingEvent } from '../utils'

export default function trackPlanSelectorPlanCycleClicked({
  payload,
  user,
}: PlanSelectorPlanCycleClickedTrackingArguments): void {
  const canPerformTrackingEvent = shouldPerformTrackingEvent({
    user,
  })

  if (!canPerformTrackingEvent) {
    return
  }

  const organization = getOrganization(user)
  const commonTrackingProperties =
    organization?.commonTrackingProperties || null

  const eventData = {
    organizationId: organization?.id || null,
    cycle: payload?.cycle || null,
    ...commonTrackingProperties,
    hasPaymentDetails: hasPaymentDetails(user) || null,
    channelQuantity: payload?.channelQuantity || null,
  }

  BufferTracker.planSelectorPlanCycleClicked(eventData)
}
